import { z } from 'zod'

export const zodUuidSchema = z.guid()
export const zodDaySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
export const zodIntegrationEntityIdSchema = z.union([
  zodUuidSchema,
  z
    .string()
    .min(1)
    .max(20)
    .regex(/^[a-zA-Z0-9]+$/),
  z.string().regex(/^pey_[a-zA-Z0-9]+$/),
  z.string().regex(/^\d+-\d+$/), // QuickBooks line item format: estimateId-lineId (e.g., "247-1")
])
